import { fieldTypes } from '../../../../constants/constant';
import { Fields } from '../../../../modules/dynamic-form-builder/model/formBuilderInterface';
export const LABELS = {
  SUBMISSION_FORM: 'Submission Form',
  SUBMIT: 'Submit',
  CANCEL: 'Cancel',
  SUBMISSION_ACCEPTED: 'Submission Successful!',
  THANKS_FOR_PARTICIPATING: 'Thank you, your entry has been accepted.',
  QUESTION: 'Question',
  GIVEAWAY_RESPONSE_FORM: 'Giveaway Response Form',
  GOVEAWAY_POLICY: 'By entering this Giveaway, you agree to our',
};
export const RESPONSE_FIELD: Fields = {
  sections: [
    {
      title: '',
      fields: [
        {
          type: fieldTypes.TEXT_AREA,
          label: '',
          placeholder: 'Type your response...',
          name: 'answer',
          class: 'col-12',
          maxlength: 500,
          validation: {
            required: {
              message: 'Response is required'
            },
            maxlength: {
              value: 500,
              message: 'Maximum 500 characters are allowed'
            }
          }
        }
      ]
    }
  ]
};
